module.exports = __webpack_public_path__ + "img/Arduino.23260cf6.png";